import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../services/AuthContext";
import { fetchOrderStates, getOrders } from "../../services/OrderServices";
import { Alert, Button, Col, FormSelect, Modal, Row, Table } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { GlobalFunctionsContext } from "../../services/GlobalFunctionsContext";
import { PageContext } from "../../services/PageContext";
import CustomPagination from "../../components/Pagination";
import { addToCart } from "../../services/CartServices";

export default function UserProfileOrders() {
  const { currentPage, totalPages, itemsPerPage, paginate, handleLimitChange, setTotalPages, pageGroup } = useContext(PageContext);
  const { user, updateCart, setNotAddedCart } = useContext(AuthContext);
  const { formatCurrency, formatNumber } = useContext(GlobalFunctionsContext)
  const [orders, setOrders] = useState([]);
  const [ states, setStates ] = useState([])
  const [stateId, setStateSelected ] = useState(1)
  const navigate = useNavigate()
  const [showModal, setShowModal] = useState(false)
  const [orderId, setOrderid] = useState(0)

  useEffect(()=>{
    let params = {
      page: currentPage,
      itemsPerPage: itemsPerPage,
      user: user.id,
      isSeller: user.isSeller,
      state: stateId,
      notAdmin: user.isSeller
    }
    getOrders(params)
      .then((data) => {
        setOrders(data.pedidos);
        setTotalPages(data.totalPages);
      })
      .catch(err => console.log(err))
  },[user, currentPage, stateId]);

  useEffect(()=>{
    fetchOrderStates()
    .then((data)=>{
      setStates(data)
    })
    .catch()
  },[])

  const confirmAddCart = (id) => {
    setOrderid(id)
    setShowModal(true)
  }

  const handleAddToCart = () => {
    const params = {
      id: orderId,
      state: stateId
    }
    setShowModal(false)
    addToCart(params)
    .then(data => {
      updateCart(data.data)
      setNotAddedCart(data.notAdded.length>0)
      navigate('/carrito')
    })
    .catch(err => console.log(err))
  }

  return (
    <>
      
        <div className="order-conent">
          <Row>
            <Col xs lg="2">
              <label>Cant. por Pag.</label>
              <FormSelect id="limit" value={itemsPerPage} onChange={handleLimitChange}>
                {pageGroup.map((item)=> {
                  return <option value={item} key={`limit_${item}`}>{item}</option>
                })}
              </FormSelect>
            </Col>
            <Col xs lg="2">
              <label>Estado</label>
              <FormSelect id="limit" value={stateId} onChange={(e)=>{setStateSelected(e.target.value)}}>
                {states.map((item)=> {
                  return <option value={item.id} key={`state_${item.id}`}>{item.nombre}</option>
                })}
              </FormSelect>
            </Col>
          </Row>
          <Table responsive>
            <thead>
              <tr>
                <th>Fecha</th>
                {user.isSeller && <th>Cliente</th>}
                <th>Pedido</th>
                <th>Estado</th>
                <th>Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {orders.length > 0 
                ?
                orders.map((ord)=>{
                  return (
                    <tr>
                      <td class="align-middle">{ord.date}</td>
                      {user.isSeller && <td>{ord.client}</td>}
                      <td class="align-middle">{formatNumber(ord.id)}</td>
                      <td class="align-middle"><span className="multiple-data">{ord.state} {ord.vendedor_id && <div className="dot"></div>}{ord.admin_id && <> <div className="admin dot"></div><small>(Admin)</small></>}</span></td>
                      <td class="align-middle">{formatCurrency(ord.total)}</td>
                      <td>
                        {stateId !== 3
                          ?<>
                              <div><Link to={`/perfil-usuario/detalle_pedido/${ord.id}`}>Ver Pedido</Link></div>
                              <div><Link to={``} onClick={()=>confirmAddCart(ord.id)}>Repetir Pedido</Link></div>
                            </>
                          :<>
                              <div><Link to={`/perfil-usuario/detalle_pedido_finalizado/${ord.id}`}>Ver Pedido</Link></div>
                              <div><Link to={``} onClick={()=>confirmAddCart(ord.id)}>Repetir Pedido</Link></div>
                            </>
                        }
                      </td>
                    </tr>
                  )
                })
                :<tr><td colSpan={6}>Todavia no realizo ningun pedido</td></tr>
              }
            </tbody>
          </Table>
          <CustomPagination currentPage={currentPage} goToPage={paginate} totalPages={totalPages} />
        </div>
        <Modal show={showModal}>
          <Alert.Heading>Repetir Pedido</Alert.Heading>
          <p>Se creara un carrito nuevo con los productos del pedido seleccionado. 
          Tenga en cuanta que el carrito actual se le eliminara por completo.</p>
          <hr />
          <div className="btn-content right">
            <Button onClick={() => handleAddToCart()} variant="primary" className="small">
              Aceptar
            </Button>
            <Button onClick={() => setShowModal(false)} variant="secondary" className="small">
              Cancelar
            </Button>
          </div>
        </Modal>
    </>
    

  )
}